/* global __webpack_public_path__:writable */
/* exported __webpack_public_path__ */
// eslint-disable-next-line
const portalName = 'coverhub-portal';
// console.log('og path', window.location.pathname)
__webpack_public_path__ = window.location.pathname.includes(portalName) ? window.location.pathname.substring(0, window.location.pathname.lastIndexOf(portalName) + portalName.length) + '/' : '/';
// console.log('public path: ', __webpack_public_path__)
